var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('div',{staticClass:"blog"},[_c('ListPosts',{attrs:{"posts":_vm.posts}}),(_vm.ready && !_vm.loading && _vm.morePosts)?_c('div',{staticClass:"list__button"},[_c('a',{on:{"click":_vm.loadMore}},[_vm._v("Flere blogginnlegg")])]):_vm._e(),_c('br'),_c('br')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }